import { render, staticRenderFns } from "./OperaInformationWindow.vue?vue&type=template&id=05f6bb9b&scoped=true&"
import script from "./OperaInformationWindow.vue?vue&type=script&lang=js&"
export * from "./OperaInformationWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaInformationWindow.vue?vue&type=style&index=0&id=05f6bb9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f6bb9b",
  null
  
)

export default component.exports